import { lazy } from 'react';

const ProposalBuilder = lazy(() => import('@/pages/ProposalBuilder'));
const ProposalManagement = lazy(() => import('@/pages/ProposalManagement'));

export const proposalRoutes = [
  {
    path: '/app/proposals',
    element: ProposalManagement,
    requiresLayout: true,
    requiredPermissions: ['proposal.read'],
    requiredRoles: ['admin', 'manager', 'sales'],
  },
  {
    path: '/app/proposals/create/:contactId',
    element: ProposalBuilder,
    requiresLayout: false,
    requiredPermissions: ['proposal.create'],
    requiredRoles: ['admin', 'manager', 'sales'],
  },
];
